import axios from 'axios';
import type {LoginRequest} from '../interfaces/LoginRequest';

const { REACT_APP_BASE_URL } = process.env;
export const login = async (loginRequest: LoginRequest): Promise<any> => {
    const authType = "JWT";
    try {
        const SC_URL = `${REACT_APP_BASE_URL?.replace('/avatar-core/', '')}/sc/api/auth`
        const response = await axios.post(`${SC_URL}`, {
            ...loginRequest
        }, {
            headers: {
                'Authorization': 'Basic ' + btoa(loginRequest.userName + ':' + loginRequest.password),
                'authType': authType,
                'appVar': 'avadmin'
            }
        });
        return response.data;
    } catch (error: any) {
        // Do NOT log the error or any of its fields: an axios error carries error.config
        // (the Basic-auth header = base64(user:password)) and the request body, i.e. the
        // credentials (CWE-532). Keep the message static — no variables in the log.
        console.error('Login request failed.');
        if (error.response?.status === 401) {
            throw new Error('Invalid username or password. Please try again.');
        }
        throw error;
    }
}

export const mockLogin = async (loginRequest: LoginRequest): Promise<any> => {
    // Mocking a successful login response. Never log loginRequest or any of its
    // fields — the username is PII and the password is a secret (CWE-532).
    void loginRequest;
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                content: {
                    accessToken: 'mockAccessToken',
                    refreshToken: 'mockRefreshToken',
                    firstName: 'John',
                    lastName: 'Doe',
                    identity: 'mockIdentity'
                }
            });
        }, 1000);
    });
}
